import SvgIcon from "./IconEdit.svg?react";
const IconEdit = SvgIcon;
export default IconEdit;
